import type { AxiosInstance } from 'axios';
import axios from 'axios';
import { getInitLoginStatus } from '../hooks/useLogin';

const axiosInstance = axios.create({});

axiosInstance.interceptors.request.use((request) => {
  const loginInfo = getInitLoginStatus();
  if (request.data) {
    request.data.operator = loginInfo.username;
  }
  request.headers['x-username'] = loginInfo.username;
  return request;
});

axiosInstance.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    return response.data;
  },
  function (error) {
    return Promise.reject(error.response.data || '后端错误');
  }
);

// export default axios;
export const request = <T = any>(
  ...args: Parameters<AxiosInstance['post']>
): Promise<T> => axiosInstance.post(...args);

export const query = <T = any>(
  ...args: Parameters<AxiosInstance['get']>
): Promise<T> => axiosInstance.get(...args);

export default request;
